// extracted by mini-css-extract-plugin
export var isOpen = "Submenu-module--is-open--21175";
export var megaMenuItem = "Submenu-module--mega-menu-item--d6e76";
export var submenu = "Submenu-module--submenu--f2bad";
export var submenuItem = "Submenu-module--submenu-item--308b1";